import React, { useState } from 'react';
import '../styles/Navbar.css';
import Logo from '../images/qiblalogo2.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false); // Close the menu when clicking on the overlay
  };

  return (
    <>
      <nav className="navbar">
        {/* Logo or Brand Name */}
        <img src={Logo} alt="Qibla Schools Logo" className="navbar-logo" />

        {/* Hamburger Menu Button */}
        <div
          className={`hamburger ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>

        {/* Links and Button */}
        <div className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <ul className="navbar-links">
            <li><a href="/">Home</a></li>
            <li><a href="/the-need">The Need</a></li>
            <li><a href="/approach">Approach</a></li>
            <li><a href="/free-courses">Free Courses</a></li>
            <li><a href="/collaborations">Collaborations</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/donations">Donations</a></li>
            <li><a href="/updates">Updates</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
          {/* <button className="navbar-button">Contact Us</button> */}
        </div>
      </nav>

      {/* Menu Overlay */}
      <div
        className={`menu-overlay ${isMenuOpen ? 'active' : ''}`}
        onClick={closeMenu}
      ></div>
    </>
  );
};

export default Navbar;
